import React from 'react';
import PropTypes from 'prop-types';
import { CompanyLabel } from '../../shared/components/CompanyLabel';
import { WorkLabel } from '../../shared/components/WorkLabel';
import { WorkerLabel } from '../../shared/components/WorkerLabel';
import { MachineLabel } from '../../shared/components/MachineLabel';
import { DocumentLabel } from '../../shared/components/DocumentLabel';
import { UserLabel } from '../../shared/components/UserLabel';
import './NotificationPreviewListItem.css';

export class NotificationPreviewListItem extends React.Component {

    render() {
        const { notification } = this.props;

        return (
            <li className="ps-preview-notification">
                <div className="ps-preview-notification-icon">
                    <i className="material-icons">{notification.icon()}</i>
                </div>
                <div className="ps-preview-notification-time">
                    <i className="material-icons">access_time</i>
                    <span>{notification.dateDescription()}</span>
                </div>
                <div className="ps-preview-notification-title">
                    {notification.title()}
                </div>
                <div className="ps-preview-notification-labels">
                    <UserLabel user={notification.user()}/>
                    <CompanyLabel company={notification.company()}/>
                    <WorkLabel work={notification.work()}/>
                    <WorkerLabel worker={notification.worker()}/>
                    <MachineLabel machine={notification.machine()}/>
                    <DocumentLabel document={notification.document()}/>
                </div>
                <div className="ps-preview-notification-message">
                    {notification.message() || '-'}
                </div>
            </li>
        );
    }
}

NotificationPreviewListItem.propTypes = {
    notification: PropTypes.object.isRequired,
};

NotificationPreviewListItem.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/preview-list/NotificationPreviewListItem.jsx